export default "__VITE_ASSET__58st$9E1__"